import { createSlice } from "@reduxjs/toolkit";
import api, { TOKEN_NAME } from "../api";
import { clearRedux } from "./resourceSlice";

const initialState = {};

const deleteCookie = (name) => {
  document.cookie = name + "=; expires=Thu, 01 Jan 1970 00:00:01 GMT;";
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    authenticateUser(state) {
      state.isAuthenticated = true;
    },
    deAuthenticateUser(state, action) {
      localStorage.removeItem(TOKEN_NAME);
      state.isAuthenticated = false;
      deleteCookie("csrftoken");
    },
    setUserId(state, { payload }) {
      const id = payload;
      state.userId = id;
    },
  },
});

export const { authenticateUser, deAuthenticateUser, setUserId } =
  userSlice.actions;

export const isAuthenticated = () => async (dispatch, state) => {
  try {
    const result = await api.get("user/is-authenticated/");
    dispatch(setUserId(result.data.id));
    dispatch(authenticateUser());
  } catch (error) {
    dispatch(deAuthenticateUser());
    console.error(error);
  }
};

export const logInUser =
  ({ data }) =>
  async (dispatch, state) => {
    try {
      const result = await api.post(`user/login/`, data);
      dispatch(setUserId(result.data.id));
      dispatch(authenticateUser());
      localStorage.setItem(TOKEN_NAME, result.data.token);
    } catch (error) {
      dispatch(deAuthenticateUser());

      return { error };
    }
  };

export const logoutUser = () => async (dispatch) => {
  try {
    await api.post(`user/logout/`);
    dispatch(clearRedux());
  } catch (error) {
    console.error(error);
  } finally {
    dispatch(deAuthenticateUser());
  }
};

export const getUser = (state) => state.user;
export const isUserAuthenticated = (state) => state.user.isAuthenticated;
export const getUserId = (state) => state.user.userId;

export default userSlice.reducer;
